import { render, staticRenderFns } from "./BoletosSec.vue?vue&type=template&id=2b728d6b&scoped=true"
import script from "./BoletosSec.vue?vue&type=script&lang=js"
export * from "./BoletosSec.vue?vue&type=script&lang=js"
import style0 from "./BoletosSec.vue?vue&type=style&index=0&id=2b728d6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b728d6b",
  null
  
)

export default component.exports